import { render } from "./AdminPRTimeline.vue?vue&type=template&id=2ebf6808"
import script from "./AdminPRTimeline.vue?vue&type=script&lang=js"
export * from "./AdminPRTimeline.vue?vue&type=script&lang=js"

import "./AdminPRTimeline.vue?vue&type=style&index=0&id=2ebf6808&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__